<p-toast></p-toast>
<!-- <div class="flex justify-content-center my-1">
  <div class="row-12">
   
    <div *ngIf="showStatusMessage" class="response-text">
    <div class="response-text">
      <span [ngStyle]="{'color': 'black'}">Status:&nbsp;</span>
      <span [ngStyle]="{'color': isErrorStatus == true ? 'red' : 'green'}">{{ statusMessageText }}</span>
    </div>

    <button (click)="findMemberIdFromUID()" *ngIf="isAadharNumberFound" pButton pRipple type="button" label="{{'Fetch Data from PPP Portal' | translate}}"
        class="p-button-secondary"><img class="mr-1" src="../../../../assets/activitiesImages/newitem.gif"></button>
    
  </div>
</div> -->

<!-- <div class="custom-flex my-1">
  <div *ngIf="showStatusMessage" class="response-text">
    <span [ngStyle]="{'color': 'black'}">PPP Id Status:&nbsp;</span>
    <span [ngStyle]="{'color': isErrorStatus ? 'red' : 'green'}">{{ statusMessageText }}</span>
  </div>

  <button (click)="findMemberIdFromUID()" *ngIf="isAadharNumberFound && isPPPDataNotValidated" pButton pRipple
    type="button" label="{{'Fetch Data from PPP Portal' | translate}}" class="p-button-secondary"><img class="mr-1"
      src="../../../../assets/activitiesImages/newitem.gif"></button>
</div> -->

<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<div *ngIf="isNotRegistered" class="card flex justify-content-center w-100 mt-3"
  style="font-size: 1.0rem; color: rgb(168, 15, 15); font-weight: bold;">
  {{ 'Farmer Not registered. Please complete your KYC' | translate }}
</div>

<div *ngIf="isLoading" class="flex justify-content-center w-100 mt-3"
  style="font-size: 1.0rem; color: rgb(168, 15, 15); font-weight: bold;">
  {{ 'Loading Farmer details...' | translate }}
</div>
<div class="col-12" *ngIf="pppIDData">
  <div class="card" reflow="true">
    <h5 [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold'}">{{'Data from PPP Portal' | translate}}</h5>

    <div class="flex flex-wrap">
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Family Id' | translate}}:</label>
          <span><b> {{pppIDData.familyID}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Member Id' | translate}}:</label>
          <span><b> {{pppIDData.memberID}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Name' | translate}}:</label>
          <span><b> {{pppIDData.fullName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'DOB' | translate}}:</label>
          <span><b> {{pppIDData.dob}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Gender' | translate}}:</label>
          <span><b> {{pppIDData.gender}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Caste' | translate}}:</label>
          <span><b> {{pppIDData.casteCategoryName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Father Name' | translate}}:</label>
          <span><b> {{pppIDData.fatherFullName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Mother Name' | translate}}:</label>
          <span><b> {{pppIDData.motherFullName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'House No' | translate}}:</label>
          <span><b> {{pppIDData.houseNo}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Street' | translate}}:</label>
          <span><b> {{pppIDData.streetNo}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Landmark' | translate}}:</label>
          <span><b> {{pppIDData.address_LandMark}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Tehsil' | translate}}:</label>
          <span><b> {{pppIDData.tehsilName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'District' | translate}}:</label>
          <span><b> {{pppIDData.districtName}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Pincode' | translate}}:</label>
          <span><b> {{pppIDData.pinCode}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Total Income' | translate}}:</label>
          <span><b> {{pppIDData.totalIncome}}</b></span>
        </span>
      </div>
      <div class="field col-12 md:col-3">
        <span>
          <label htmlFor="block">{{'Family Income' | translate}}:</label>
          <span><b> {{pppIDData.familyIncome}}</b></span>
        </span>
      </div>

    </div>





    <div>

    </div>


  </div>
</div>

<div class="col-12 card personal-details-card" *ngIf="!isLoading && farmerData && farmerData?.IsAutomatedData == 1">
<!-- <div class="col-12 card personal-details-card" *ngIf="!isLoading && farmerData"> -->
  <!-- for new users -->
  <div class="flex justify-content-center succes-msg">
    <p>e-KYC Successfully Completed</p>
  </div>

  <!-- <h5 [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold'}">{{'FARMERS_DETAILS' | translate}}</h5> -->
  <form [formGroup]="farmersDetailsForm">

    <div class="p-fluid p-formgrid grid">
      <div class="field col-12 md:col-4">
        <div class="field col-12 md:col-12">
          <label htmlFor="fatherName">{{'FATHERS_NAME' | translate}}</label>
          <input readonly class="readonly" formControlName="fathersName" pInputText id="fatherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.fathersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.fathersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.fathersName.errors.required">{{'FATHERS_NAME_IS_REQUIRED' | translate}}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-12">
          <label htmlFor="motherName">{{'MOTHER_NAME' | translate}}</label>
          <input readonly class="readonly" formControlName="mothersName" pInputText id="motherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mothersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.mothersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mothersName.errors.required">{{'MOTHERS_NAME_IS_REQUIRED' | translate}}
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-12">
          <label htmlFor="block">{{'DATE_OF_BIRTH' | translate}}</label>
          <p-calendar [disabled]="true" class="readonly" [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true"
            dateFormat="dd-mm-yy" formControlName="dob"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.dob.errors }"></p-calendar>
          <div *ngIf="isSubmitted && farmersFormControls.dob.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.dob.errors.required">{{'DATE_OF_BIRTH_IS_REQUIRED' | translate}}</div>
          </div>
        </div>
      </div>

      <div class="field col-12 md:col-5">
        <div class="field col-12 md:col-12">
          <label htmlFor="gender">{{'GENDER' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" formControlName="gender" value="M" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'MALE' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" formControlName="gender" value="F" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'FEMALE' | translate}}</label>
              </div>
            </div>
            <div class="field mr-0">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" formControlName="gender" value="T" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'TRANSGENDER' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
  
        <div class="field col-12 md:col-12">
          <label htmlFor="block">{{'CASTE' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" (onClick)="onCasteChange($event)" formControlName="caste" value="1"
                  id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" (onClick)="onCasteChange($event)" formControlName="caste" value="2"
                  id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton [disabled]="true" (onClick)="onCasteChange($event)" formControlName="caste" value="3"
                  id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'SC/ST' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
  
        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'EMAIL_ID' | translate}}</label>
          <input formControlName="emailId" pInputText id="fatherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.emailId.errors }" />
  
          <div *ngIf="isSubmitted && farmersFormControls.emailId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.emailId.errors.required">{{'EMAIL_ID_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.emailId.errors.email">{{'EMAIL_IS_INVALID' | translate}}</div>
          </div>
        </div> -->
  
        <div class="field col-12 md:col-12">
          <label htmlFor="fatherName">{{'MOBILE' | translate}}</label>
          <input readonly class="readonly" formControlName="mobileNo" pInputText id="mobileNo" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mobileNo.errors }" />
  
          <div *ngIf="isSubmitted && farmersFormControls.mobileNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mobileNo.errors.required">{{'MOBILE_NO_IS_REQUIRED' | translate}}</div>
  
            <div *ngIf="farmersFormControls.mobileNo.errors.minlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.maxlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.pattern">{{'MBILE_NO_SHOULD_CONTAIN' | translate}}</div>
  
          </div>
        </div>
      </div>

      <div class="field col-12 md:col-3">
        <div class="flex justify-content-center image-container text-center">
          <span>
            <img [src]="farmersFormControls.farmersPhotoPath.value" alt="Farmer's Photo" class="round-image">
            <p class="user-name">{{farmersFormControls.farmersName.value }}</p> <!-- Text below the image -->
          </span>
        </div>
      </div>


      <!-- <div *ngIf="isCasteCertificateMandatory || isCasteCertificteOptional" class="field col-12 md:col-4">
        <label htmlFor="block">{{'CASTE_CERTIFICATE' | translate}}</label>
        <div class="flex">
          <p-fileUpload accept=".jpeg,.pdf,.jpg" #casteCertificateFileUpload [customUpload]="true"
            (uploadHandler)="onUpload($event, 'casteCertificate', casteCertificateFileUpload)" name="myfile[]"
            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
          </p-fileUpload>
          <p-image *ngIf="farmersFormControls.casteCertificate.value" [src]="farmersFormControls.casteCertificate.value"
            alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
        </div>
        <div *ngIf="isSubmitted && farmersFormControls.casteCertificate.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.casteCertificate.errors.required">{{'CASTE_CERTIFICATE_IS_REQUIRED' |
            translate}}</div>
        </div>
      </div> -->

      <div class="field col-12 md:col-4">
        <label htmlFor="fatherName">{{'ADDRESS' | translate}}</label>
        <input readonly class="readonly" formControlName="address" pInputText id="fatherName" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.address.errors }" />

        <div *ngIf="isSubmitted && farmersFormControls.address.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.address.errors.required">{{'ADDRESS_IS_REQUIRED' | translate}}</div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
        <p-autoComplete [disabled]="true" formControlName="village" [(ngModel)]="selectedVillage" placeholder="Search"
          id="dd" [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
          (completeMethod)="filterVillage($event)" field="Name" value="Code"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.village.errors }"></p-autoComplete>

        <div *ngIf="isSubmitted && farmersFormControls.village.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.village.errors.required">{{'VILLAGE_NAME_IS_REQUIRED' | translate}}</div>
        </div>

      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="pinCode">{{'PINCODE' | translate}}</label>
        <input readonly class="readonly" maxlength="6" pattern="^[0-9]{6}$" pKeyFilter="int" formControlName="pincode"
          pInputText id="pinCode" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pincode.errors }" />

        <div *ngIf="isSubmitted && farmersFormControls.pincode.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.pincode.errors.required">{{'PINCODE_IS_REQUIRED' | translate}}</div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
        <input readonly class="readonly" maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo"
          pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mfmbNo.errors }" />
        <div *ngIf="isSubmitted && farmersFormControls.mfmbNo.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.mfmbNo.errors.required">{{'MFMB_NO_REQUIRED' | translate}}</div>
          <div *ngIf="farmersFormControls.mfmbNo.errors.minlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
            translate}}</div>
          <div *ngIf="farmersFormControls.mfmbNo.errors.maxlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
            translate}}</div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
        <input readonly class="readonly" maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int"
          formControlName="aadharNo" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.aadharNo.errors }" />

        <div *ngIf="isSubmitted && farmersFormControls.aadharNo.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED' | translate}}</div>
          <div *ngIf="farmersFormControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
            translate}}</div>
          <div *ngIf="farmersFormControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
            translate}}</div>
          <div *ngIf="farmersFormControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' |
            translate}}</div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="block">{{'PPP_ID' | translate}}</label>
        <input readonly class="readonly" formControlName="pppId" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pppId.errors }" />
        <div *ngIf="isSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.pppId.errors.required">{{'PPP_ID_IS_REQUIRED' | translate}}</div>
          <div *ngIf="farmersFormControls.pppId.errors.minlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
          <div *ngIf="farmersFormControls.pppId.errors.maxlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
        </div>
      </div>
    </div>

    <div class="p-fluid p-formgrid grid upload-section justify-content-center">
      <div class="field col-12 md:col-4">
        <label htmlFor="block">{{'AADHAR_PHOTO' | translate}}</label>
        <div class="flex">
          <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerAadharFileUpload [customUpload]="true"
            (uploadHandler)="onUpload($event, 'aadharPhotoPath', farmerAadharFileUpload)" name="myfile[]" mode="basic"
            [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
          </p-fileUpload>
          <p-image *ngIf="farmersFormControls.aadharPhotoPath.value" [src]="farmersFormControls.aadharPhotoPath.value"
            alt="Image" width="60" [preview]="true" class="ml-2 p-button-rounded p-button-success"
            iconPos="left"></p-image>

        </div>
        <div *ngIf="isSubmitted && farmersFormControls.aadharPhotoPath.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.aadharPhotoPath.errors.required">{{'AADHAR_PHOTO_IS_REQUIRED' | translate}}
          </div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <label htmlFor="fatherName">{{'PPP_PROOF_IMAGE' | translate}}</label>
        <div class="flex">


          <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPPPFileUpload [customUpload]="true"
            (uploadHandler)="onUpload($event, 'pppPhotoPath', farmerPPPFileUpload)" name="myfile[]" mode="basic"
            [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
          </p-fileUpload>
          <p-image *ngIf="farmersFormControls.pppPhotoPath.value" [src]="farmersFormControls.pppPhotoPath.value"
            alt="Image" width="60" [preview]="true" class="ml-2 p-button-rounded p-button-success"
            iconPos="left"></p-image>
        </div>
        <div *ngIf="isSubmitted && farmersFormControls.pppPhotoPath.errors" class="invalid-feedback">
          <div *ngIf="farmersFormControls.pppPhotoPath.errors.required">{{'PPP_PHOTO_IS_REQUIRED' | translate}}</div>
        </div>
      </div>

      <div class="field col-12 md:col-4">
        <button pButton pRipple label="Save" class="p-button-success mt-4" (click)="onUpdateDoc()">
        </button>
      </div>
    </div>
  </form>
</div>

<div class="col-12"
  *ngIf="!isLoading && farmerData && (farmerData?.IsAutomatedData == 0 || farmerData?.IsAutomatedData == null)">
<!-- <div *ngIf="false" > -->
  <div class="card" reflow="true">
    <h5 [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold'}">{{'FARMERS_DETAILS' | translate}}</h5>
    <form [formGroup]="farmersDetailsForm">


      <div class="p-fluid p-formgrid grid">
        <div class="field col-12 md:col-4">
          <label htmlFor="farmerName">{{'FARMER_NAME' | translate}}</label>
          <input formControlName="farmersName" pInputText id="farmerName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.farmersName.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.farmersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.farmersName.errors.required">{{'FARMER_NAME_IS_REQUIRED' | translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'FARMER_PHOTO' | translate}}</label>
          <div class="flex">
            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPhotoFileUpload [customUpload]="true"
              (uploadHandler)="onUpload($event, 'farmersPhotoPath', farmerPhotoFileUpload)" name="myfile[]" mode="basic"
              [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.farmersPhotoPath.value"
              [src]="farmersFormControls.farmersPhotoPath.value" alt="Image" width="60"
              class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.farmersPhotoPath.value" alt="farmer photo" *ngIf="farmersFormControls.farmersPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>

            <button *ngIf="farmersFormControls.farmersPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.farmersPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.farmersPhotoPath.errors.required">{{'FARMERS_PHOTO_IS_REQUIRED' |
              translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="gender">{{'GENDER' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="M" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'MALE' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="F" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'FEMALE' | translate}}</label>
              </div>
            </div>
            <div class="field mr-0">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="gender" value="T" id="IsSubsidyAvailabeNo"
                  [(ngModel)]="genderType"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'TRANSGENDER' | translate}}</label>
              </div>
            </div>
          </div>
          <!-- <input pInputText id="availableOnLand" type="text" /> -->
        </div>

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="block">Block</label>
          <input  pInputText id="block" type="text" />
        </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'FATHERS_NAME' | translate}}</label>
          <input formControlName="fathersName" pInputText id="fatherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.fathersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.fathersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.fathersName.errors.required">{{'FATHERS_NAME_IS_REQUIRED' | translate}}
            </div>
          </div>

          <!-- <p-dropdown [options]="dropdownItems" optionLabel="name" [(ngModel)]="selectedState"></p-dropdown> -->
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="motherName">{{'MOTHER_NAME' | translate}}</label>
          <input formControlName="mothersName" pInputText id="motherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mothersName.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.mothersName.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mothersName.errors.required">{{'MOTHERS_NAME_IS_REQUIRED' | translate}}
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'DATE_OF_BIRTH' | translate}}</label>
          <p-calendar [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
            formControlName="dob"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.dob.errors }"></p-calendar>
          <div *ngIf="isSubmitted && farmersFormControls.dob.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.dob.errors.required">{{'DATE_OF_BIRTH_IS_REQUIRED' | translate}}</div>
          </div>

          <!-- <input formControlName="dob" slotChar="mm/dd/yyyy" mask="99/99/9999" pInputText id="block" type="text" /> -->
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'EMAIL_ID' | translate}}</label>
          <input formControlName="emailId" pInputText id="fatherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.emailId.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.emailId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.emailId.errors.required">{{'EMAIL_ID_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.emailId.errors.email">{{'EMAIL_IS_INVALID' | translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'MOBILE' | translate}}</label>
          <!-- <input maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int"formControlName="mobileNo" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mobileNo.errors }"/> -->
          <div>
            <span style="font-weight: bold;">{{farmersDetailsForm.controls.mobileNo.value}}</span>
          </div>

          <div *ngIf="isSubmitted && farmersFormControls.mobileNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mobileNo.errors.required">{{'MOBILE_NO_IS_REQUIRED' | translate}}</div>

            <div *ngIf="farmersFormControls.mobileNo.errors.minlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.maxlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.mobileNo.errors.pattern">{{'MBILE_NO_SHOULD_CONTAIN' | translate}}</div>

          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'CASTE' | translate}}</label>
          <div class="formgroup-inline">
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton (onClick)="onCasteChange($event)" formControlName="caste" value="1"
                  id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'GEN' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton (onClick)="onCasteChange($event)" formControlName="caste" value="2"
                  id="IsSubsidyAvailabeYes"></p-radioButton>
                <label for="IsSubsidyAvailabeYes">{{'BC' | translate}}</label>
              </div>
            </div>
            <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton (onClick)="onCasteChange($event)" formControlName="caste" value="3"
                  id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">{{'SC/ST' | translate}}</label>
              </div>
            </div>
            <!-- <div class="field">
              <div class="field-radiobutton mb-0">
                <p-radioButton formControlName="caste" value="2" id="IsSubsidyAvailabeNo"></p-radioButton>
                <label for="IsSubsidyAvailabeNo">OBC</label>
              </div>
            </div> -->
          </div>

          <!-- <input pInputText id="block" type="text" /> -->
        </div>

        <div *ngIf="isCasteCertificateMandatory || isCasteCertificteOptional" class="field col-12 md:col-4">
          <label htmlFor="block">{{'CASTE_CERTIFICATE' | translate}}</label>
          <div class="flex">
            <p-fileUpload accept=".jpeg,.pdf,.jpg" #casteCertificateFileUpload [customUpload]="true"
              (uploadHandler)="onUpload($event, 'casteCertificate', casteCertificateFileUpload)" name="myfile[]"
              mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.casteCertificate.value"
              [src]="farmersFormControls.casteCertificate.value" alt="Image" width="60"
              class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.casteCertificate.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.casteCertificate.errors.required">{{'CASTE_CERTIFICATE_IS_REQUIRED' |
              translate}}</div>
          </div>
        </div>
        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">Aadhar Copy</label>
          <input pInputText id="fatherName" type="text" />
        </div> -->

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="block">Caste</label>
          <input pInputText id="block" type="text" />
        </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'ADDRESS' | translate}}</label>
          <input formControlName="address" pInputText id="fatherName" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.address.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.address.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.address.errors.required">{{'ADDRESS_IS_REQUIRED' | translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
          <p-autoComplete formControlName="village" [(ngModel)]="selectedVillage" placeholder="Search" id="dd"
            [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
            (completeMethod)="filterVillage($event)" field="Name" value="Code"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.village.errors }"></p-autoComplete>

          <div *ngIf="isSubmitted && farmersFormControls.village.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.village.errors.required">{{'VILLAGE_NAME_IS_REQUIRED' | translate}}</div>
          </div>

          <!-- <input formControlName="village" pInputText id="villageCode" type="text" /> -->
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="pinCode">{{'PINCODE' | translate}}</label>
          <input maxlength="6" pattern="^[0-9]{6}$" pKeyFilter="int" formControlName="pincode" pInputText id="pinCode"
            type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pincode.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.pincode.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pincode.errors.required">{{'PINCODE_IS_REQUIRED' | translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
          <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo" pInputText id="block"
            type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.mfmbNo.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.mfmbNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.mfmbNo.errors.required">{{'MFMB_NO_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.mfmbNo.errors.minlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.mfmbNo.errors.maxlength">{{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
              translate}}</div>
            <!-- <div *ngIf="farmersFormControls.mfmbNo.errors.pattern">{{'MFMB_NO_REQUIRED_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div> -->
          </div>
        </div>

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">ID Proof Type</label>
          <input pInputText id="fatherName" type="text" />
        </div> -->

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">ID Proof</label>
          <input formControlName="idProof" pInputText id="fatherName" type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.idProof.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.idProof.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.idProof.errors.required">ID Proof is required</div>
          </div>
        </div> -->

        <!-- <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
          <div *ngIf="isAadharVerified">
            <span style="font-weight: bold;">{{farmersDetailsForm.controls.aadharNo.value}}</span>
          </div>
          <input *ngIf="!isAadharVerified" maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int"  formControlName="aadharNo" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.aadharNo.errors }"/>

          <div class="aadhar-verification pt-2" *ngIf="!farmersFormControls.aadharNo.errors">
            <div class="verified-icon" *ngIf="isAadharVerified">
              <i class="fas fa-check-circle"></i>
              <div class="verified-text">{{ 'VERIFIED' | translate }}</div>
            </div>
            <div class="not-verified-icon" *ngIf="!isAadharVerified">
              <i class="fas fa-check-circle"></i>
              <div class="not-verified-text">{{ 'NOT_VERIFIED' | translate }}</div>
            </div>
            <div class="verify-text" *ngIf="!isAadharVerified">
                <a style="cursor: pointer;" (click)="verifyAadhar()">{{'CLICK_HERE_TO_VERIFY_AADHAR' | translate}}</a>
            </div>
          </div>

          <div *ngIf="isSubmitted && farmersFormControls.aadharNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' | translate}}</div>
          </div>
        </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
          <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo" pInputText id="block"
            type="text" [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.aadharNo.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.aadharNo.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
              translate}}</div>
            <div *ngIf="farmersFormControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' |
              translate}}</div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'AADHAR_PHOTO' | translate}}</label>
          <div class="flex">


            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerAadharFileUpload [customUpload]="true"
              (uploadHandler)="onUpload($event, 'aadharPhotoPath', farmerAadharFileUpload)" name="myfile[]" mode="basic"
              [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.aadharPhotoPath.value" [src]="farmersFormControls.aadharPhotoPath.value"
              alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.aadharPhotoPath.value" alt="aadhar photo" *ngIf="farmersFormControls.aadharPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>
            <button *ngIf="farmersFormControls.aadharPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.aadharPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.aadharPhotoPath.errors.required">{{'AADHAR_PHOTO_IS_REQUIRED' | translate}}
            </div>
          </div>
        </div>
        <!-- <div class="field col-12 md:col-4"> -->
        <!-- <label htmlFor="block">PPP ID</label>
          <input formControlName="pppId" pInputText id="block" type="text"
          [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pppId.errors }" />

          <div *ngIf="isSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppId.errors.required">PPP ID is required</div>
          </div> -->
        <!-- </div> -->
        <div class="field col-12 md:col-4">
          <label htmlFor="block">{{'PPP_ID' | translate}}</label>
          <input formControlName="pppId" pInputText id="block" type="text"
            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && farmersFormControls.pppId.errors }" />
          <div *ngIf="isSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppId.errors.required">{{'PPP_ID_IS_REQUIRED' | translate}}</div>
            <div *ngIf="farmersFormControls.pppId.errors.minlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
            <div *ngIf="farmersFormControls.pppId.errors.maxlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS' | translate}}</div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <label htmlFor="fatherName">{{'PPP_PROOF_IMAGE' | translate}}</label>
          <div class="flex">


            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPPPFileUpload [customUpload]="true"
              (uploadHandler)="onUpload($event, 'pppPhotoPath', farmerPPPFileUpload)" name="myfile[]" mode="basic"
              [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
            </p-fileUpload>
            <p-image *ngIf="farmersFormControls.pppPhotoPath.value" [src]="farmersFormControls.pppPhotoPath.value"
              alt="Image" width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

            <!-- <div class="image-background ml-2">

              <img [src] ="farmersFormControls.idProofPhotoPath.value" alt="id photo" *ngIf="farmersFormControls.idProofPhotoPath.value"  class="ml-2 p-button-rounded p-button-success" iconPos="left">
            </div>

            <button *ngIf="farmersFormControls.idProofPhotoPath.value" pButton type="button" icon="pi pi-check" class="ml-2 p-button-rounded p-button-success" iconPos="left"></button> -->
          </div>
          <div *ngIf="isSubmitted && farmersFormControls.pppPhotoPath.errors" class="invalid-feedback">
            <div *ngIf="farmersFormControls.pppPhotoPath.errors.required">{{'PPP_PHOTO_IS_REQUIRED' | translate}}</div>
          </div>
        </div>


      </div>
    </form>
    <div *ngIf="!(isEditable == 0)">
      <button (click)="onFarmersFormSubmit()" pButton pRipple type="button" label="{{'SAVE' | translate}}"
        class="p-button-success mr-2 mb-2"></button>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showAadharVerDialog" [style]="{width: '550px'}" header="{{ 'VERIFY_AADHAR_NUMBER' | translate}}"
  [modal]="true" [baseZIndex]="-100" styleClass="p-fluid" (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
      style="display: flex; flex-wrap:wrap">
      <img src="../../../../assets/aadhar/aadhar1.jpeg" alt="bg" style="width:100%;">
      <div class="inner-div">
        <div class="field md:col-12 col-12 aadhar-number">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'AADHAR_NUMBER'| translate}}: <label class="px-2"
              [style]="{color: 'rgb(148, 9, 9)'}">{{ aadharNumber }}</label></label>
        </div>

        <div class="field md:col-12 col-12 edit-aadhar">
          <a class="d-flex flex-row-reverse" (click)="editAadharNumber()" style="cursor: pointer;">{{
            "CLICK_HERE_TO_EDIT_AADHAR_NUMBER" | translate }}</a>
        </div>

        <div class="field md:col-12 col-12 otp-field">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'ENTER_OTP'| translate}}:
          </label>
          <input pInputText maxlength="6" [(ngModel)]="aadharVerOTP" placeholder="OTP" type="number">
        </div>

        <div class="field md:col-12 col-12 resendOTP">
          <div class="timer resendOTP" *ngIf="timer > 0">Resend OTP in: {{ timer }} Seconds</div>
          <a *ngIf="timer === 0" (click)="resendOTP()" style="cursor: pointer;">Resend OTP</a>
          <!-- <p-button label="Resend OTP" severity="secondary" *ngIf="timer === 0" (click)="resendOTP()"></p-button> -->
        </div>

        <div class="field md:col-12 col-12">
          <button pButton pRipple label="{{ 'SUBMIT_OTP' | translate}}" class="p-button-success"
            (click)="submitOTP()"></button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
      (click)="hideDialog()"></button>
    <!-- <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button> -->
  </ng-template>
</p-dialog>


<p-dialog [(visible)]="openPPIDDialog" [style]="{width: '900px'}" header="{{ 'PPP ID Deatils' | translate}}"
  [modal]="true" [baseZIndex]="-100" styleClass="p-fluid" (onHide)="hidePPIDDialog()">
  <ng-template pTemplate="content">
    <div *ngIf="showPPPIdValidationBox" class="p-fluid p-formgrid justify-content-center ver-dialog mt-2 outer-div"
      style="display: flex; flex-wrap:wrap">
      <!-- <div class="field md:col-12 col-12 aadhar-number">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'AADHAR_NUMBER'| translate}}: <label class="px-2" [style]="{color: 'rgb(148, 9, 9)'}">{{ aadharNumber  }}</label></label>
      </div> -->

      <!-- <div class="field md:col-12 col-12 edit-aadhar">
        <a class="d-flex flex-row-reverse" (click)="editAadharNumber()" style="cursor: pointer;">{{ "CLICK_HERE_TO_EDIT_AADHAR_NUMBER" | translate }}</a>
      </div> -->

      <div>
        <div class="field md:col-12 col-12 otp-field">
          <label [style]="{color: 'rgb(3, 2, 2)'}">{{'Member ID'| translate}}:
          </label>
          <!-- <input *ngIf="!openPPIDDOOTPBox" pInputText maxlength="8" [(ngModel)]="PPPIdValue" placeholder="PPP ID" type="text">   -->
          <input readonly pInputText maxlength="8" [(ngModel)]="fetchedMemberId" placeholder="PPP ID" type="text">
        </div>

        <!-- <div class="field md:col-12 col-12">
        <button [disabled]="isMemberIdFound" pButton pRipple label="{{ 'Send OTP' | translate}}" class="p-button-success"></button>
      </div> -->
        <div>
          <div class="field md:col-12 col-12 otp-field">
            <label [style]="{color: 'rgb(3, 2, 2)'}">{{'Enter OTP'| translate}}:
            </label>
            <input pInputText maxlength="6" [(ngModel)]="memberIdOTPValue" placeholder="OTP" type="number">
          </div>

          <div class="field md:col-12 col-12">
            <button pButton pRipple label="{{ 'SUBMIT_OTP' | translate}}" class="p-button-success"
              (click)="onSubmitMemIdOTP()"></button>
          </div>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template pTemplate="footer">
    <!-- <button *ngIf="isMemberIdFound" pButton pRipple label="{{'BACK'| translate}}" icon="pi pi-check" class="p-button-text" (click)="onClickBack()"></button> -->

    <button pButton pRipple label="{{'CANCEL' | translate}}" icon="pi pi-times" class="p-button-text"
      (click)="hidePPIDDialog()"></button>
    <!-- <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button> -->
  </ng-template>
</p-dialog>